import enUS from './en-US.json'

const messages = {}
Object.keys(enUS).forEach(key => {
    messages[key] = key
})

export default messages



// WEBPACK FOOTER //
// ./src/i18n/locales/zh-CN.js